import React from 'react';
import PropTypes from 'prop-types';
import { Card, Container } from 'reactstrap';
import { useLocation, Link } from 'react-router-dom';
import { useBoolean } from 'usehooks-ts';

import AppBreadcrumb from 'components/App/Breadcrumb';
import AppMeta from 'components/App/Meta';
import DataTableLocationDetailPriceType from 'components/App/DataTableLocationDetailPriceType';
import ModalSuccess from 'components/Modals/ModalSuccess';
import ModalRequestAction from 'components/Modals/ModalRequestAction';

import images from 'assets/images';

import { LOCATIONS } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';
import MODAL_TYPE from 'constants/modalType';

import styles from './PriceType.module.scss';

const breadcrumbList = [
  {
    name: 'Giá và tình trạng phòng trống',
    isActive: false,
    link: LOCATIONS.LOCATION_LIST,
  },
  {
    name: 'Loại giá',
    isActive: true,
    link: '',
  },
];

function PriceType(props) {
  const {
    isLoadingGetPLacePriceTypes,

    placePriceTypes,

    modalType,

    actionGetPlacePriceTypes,
    actionDeletePlacePriceTypes,
    actionCloseModalCreateRoomSuccess,
  } = props;

  const {
    value: isOpenModalDeletePlacePriceTypes,
    setFalse: onCloseModalDeletePlacePriceTypes,
    setTrue: onOpenModalDeletePlacePriceTypes,
    toggle: onToggleModalDeletePlacePriceTypes,
  } = useBoolean(false);

  const [priceId, setPriceId] = React.useState('');
  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const onCancelModalDeletePlacePriceTypes = React.useCallback(() => {
    onCloseModalDeletePlacePriceTypes();
  }, [onCloseModalDeletePlacePriceTypes]);

  const reloadPlacePriceTypesOnSave = React.useCallback(() => {
    actionGetPlacePriceTypes({ placeId });
    onCloseModalDeletePlacePriceTypes();
  }, [actionGetPlacePriceTypes, onCloseModalDeletePlacePriceTypes, placeId]);

  const onConfirmDeletePlacePriceTypes = React.useCallback(() => {
    actionDeletePlacePriceTypes({ priceId, placeId, reloadPlacePriceTypesOnSave });
  }, [actionDeletePlacePriceTypes, placeId, priceId, reloadPlacePriceTypesOnSave]);

  React.useEffect(() => {
    if (placeId) {
      actionGetPlacePriceTypes({ placeId });
    }
  }, [actionGetPlacePriceTypes, placeId]);

  return (
    <div className={`page-content ${styles.Page}`}>
      <AppMeta
        name="Loại giá"
      />

      <Container fluid>
        <AppBreadcrumb
          pageTitle="Loại giá"
          breadcrumbList={breadcrumbList}
        />

        <Card className="Section">
          <div className="Section__Header">
            <p className="Text">
              Tạo và xem lại các loại giá khác nhau dành cho
              khách hàng. Quý vị có thể quản lý giá và tình trạng
              phòng trống trong
              <Link to={`${LOCATIONS.LOCATION_DETAIL.DETAIL_CALENDAR}?place=${placeId}`} className="TextLink">
                &nbsp;Lịch
              </Link>
            </p>

            <Link
              className="col-md-2 BtnAdd"
              to={`${LOCATIONS.LOCATION_DETAIL.ADD_PRICE_TYPE}?place=${placeId}`}
            >
              <i className="fas fa-plus" />

              Thêm loại giá mới
            </Link>
          </div>

          <DataTableLocationDetailPriceType
            isLoadingGetPLacePriceTypes={isLoadingGetPLacePriceTypes}
            placePriceTypes={placePriceTypes}
            placeId={placeId}
            onOpenModalDeletePlacePriceTypes={onOpenModalDeletePlacePriceTypes}
            setPriceId={setPriceId}
          />
        </Card>
      </Container>

      <ModalSuccess
        isOpen={modalType === MODAL_TYPE.CREATE_PRICE_SUCCESS
          || modalType === MODAL_TYPE.EDIT_PRICE_SUCCESS}
        onCloseModal={actionCloseModalCreateRoomSuccess}
        message={modalType === MODAL_TYPE.CREATE_PRICE_SUCCESS ? 'Thêm loại giá mới thành công' : 'Chỉnh sửa loại giá thành công'}
      />

      <ModalRequestAction
        isOpen={isOpenModalDeletePlacePriceTypes}
        icon={images.modalGarbageCan.default}
        textRequest="Bạn có chắc muốn xóa loại giá này không?"
        onToggle={onToggleModalDeletePlacePriceTypes}
        onCloseModal={onCancelModalDeletePlacePriceTypes}
        onConfirm={onConfirmDeletePlacePriceTypes}
      />

      <ModalRequestAction
        isOpen={isOpenModalDeletePlacePriceTypes}
        icon={images.modalGarbageCan.default}
        textRequest="Bạn có chắc muốn xóa loại giá này không?"
        onToggle={onToggleModalDeletePlacePriceTypes}
        onCloseModal={onCancelModalDeletePlacePriceTypes}
        onConfirm={onConfirmDeletePlacePriceTypes}
      />
    </div>
  );
}

PriceType.propTypes = {
  isLoadingGetPLacePriceTypes: PropTypes.bool,

  placePriceTypes: PropTypes.instanceOf(Array),

  modalType: PropTypes.string,

  actionGetPlacePriceTypes: PropTypes.func,
  actionDeletePlacePriceTypes: PropTypes.func,
  actionCloseModalCreateRoomSuccess: PropTypes.func,
};

PriceType.defaultProps = {
  isLoadingGetPLacePriceTypes: false,

  placePriceTypes: INITIAL_VALUE.ARRAY,

  modalType: '',

  actionGetPlacePriceTypes: INITIAL_VALUE.FUNCTION,
  actionDeletePlacePriceTypes: INITIAL_VALUE.FUNCTION,
  actionCloseModalCreateRoomSuccess: INITIAL_VALUE.FUNCTION,
};

export default PriceType;
